import React from "react";

// theme: light
export default function BadgeNumber({ count, theme = "default", imgSrc }) {
  return (
    <div className={`badge-counter badge-counter-${theme}`}>
      {imgSrc && <img src={imgSrc} alt="count-icon" className="count-icon" />}
      <p className="count">{count}</p>
    </div>
  );
}
